import { Modal } from '@magicdoorinc/ui';
import type { Component } from 'solid-js';

export const YouTubeVideoModal: Component<{
  visible: boolean;
  onClose: () => void;
  videoId: string;
  title: string;
  description: string;
}> = (props) => {
  return (
    <Modal visible={props.visible} onCancel={props.onClose} title={props.title} size="lg" class="px-2">
      <div class="relative w-full pb-[56.25%]">
        <iframe
          src={`https://www.youtube.com/embed/${props.videoId}`}
          title={props.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="absolute left-0 top-0 size-full rounded-lg"
        />
      </div>
      <div class="mt-4 text-sm text-text-02">{props.description}</div>
    </Modal>
  );
};
